// Pfad der Bilder: X:\v0\putz-estrich-v0\website\src\app\[locale]\assets\images

// Projekt Modernes Wohnhaus Klagenfurt
// import modernes_wohnhaus_0 from "../../assets/images/projects/modernes-wohnhaus-klagenfurt/modernes-wohnhaus.png"
// import modernes_wohnhaus_1 from "../../assets/images/projects/modernes-wohnhaus-klagenfurt/modernes-wohnhaus-1.jpg"

// Project Burggemäuer, Denkmalschutz und mehr
import burggemauuer_0 from "../../assets/images/projects/burgmauer/burggemauuer-0.jpg";
import burggemauuer_1 from "../../assets/images/projects/burgmauer/burggemauuer-1.jpg";
import burggemauuer_2 from "../../assets/images/projects/burgmauer/Ref_02_08.jpg";
import burggemauuer_3 from "../../assets/images/projects/burgmauer/Ref_02_11.jpg";
import burggemauuer_4 from "../../assets/images/projects/burgmauer/Ref_02_18.jpg";
import burggemauuer_5 from "../../assets/images/projects/burgmauer/Ref_02_15.jpg";
import burggemauuer_6 from "../../assets/images/projects/burgmauer/Ref_02_12.jpg";
import burggemauuer_7 from "../../assets/images/projects/burgmauer/Ref_02_13.jpg";
import burggemauuer_8 from "../../assets/images/projects/burgmauer/Ref_02_04.jpg";

// Projekt Landhaus
import landhaus_0 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_06.webp";
import landhaus_1 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_01.webp";
import landhaus_2 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_02.webp";
import landhaus_3 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_03.webp";
import landhaus_4 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_04.webp";
import landhaus_5 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_05.webp";
import landhaus_6 from "../../assets/images/projects/landhaus-mit-thermischer-sanierung/Ref_01_07.webp";

// locale]\assets\images\projects\modernes-wohnhaus-klagenfurt

export const projectsData = [
    // {
    //     id: 1,
    //     slug: "agm-voesendorf-spezialboeden-fuer-hohe-ansprueche",
    //     project_name: "AGM Vösendorf - Spezialböden für hohe Ansprüche",
    //     project_img: project_img_2,
    //     images: [project_img_2, project_img_1, project_img_3, project_img_4],
    //     project_desc: "monolithische Bodenplatte, ca. 7.500 m², teilweise konventionell mit Hartkorneinstreuung sowie geschliffen mit Terrazzoeffekt, fugenlos bis 700 m² große Felder.",
    //     client: "AGM",
    //     area: "14,891 m²",
    //     project_year: "2020",
    //     project_type: "Spezialböden",
    //     link: "/projects/agm-voesendorf-spezialboeden-fuer-hohe-ansprueche",
    //     location:"Vösendorf, Wien, Österreich"
    // },
    // {
    //     id: 2,
    //     slug: "modernes-wohnhaus-klagenfurt",
    //     project_name: "Modernes Wohnhaus in Klagenfurt",
    //     project_img: modernes_wohnhaus_0,
    //     images: [modernes_wohnhaus_0, modernes_wohnhaus_1, project_img_1, project_img_4],
    //     project_desc: "Ausführung von Innenputz, Estrich und Vollwärmeschutzarbeiten.",
    //     client: "Privat",
    //     area: "14,891 m²",
    //     project_year: "2013",
    //     project_type: "Innenputz, Estrich, Vollwärmeschutz",
    //     link: "/projects/modernes-wohnhaus-klagenfurt",
    //     location:"Klagenfurt am Wörthersee, Kärnten, Österreich"
    // },
    {
        id: 3,
        slug: "laendliches-wohnhaus-mit-thermischer-sanierung",
        project_name: "Ländliches Wohnhaus mit thermischer Sanierung",
        project_img: landhaus_0,
        images: [landhaus_0,landhaus_1,landhaus_2,landhaus_3,landhaus_4,landhaus_5,landhaus_6],
        project_desc: "An einem ländlich gelegenen Wohnhaus wurde im Rahmen einer thermischen Sanierung ein umfassender Vollwärmeschutz ausgeführt. Auf einer Gesamtfläche von rund 400 m² erfolgte die fachgerechte Anbringung des Wärmedämmverbundsystems, um die Energieeffizienz des Gebäudes deutlich zu verbessern und den Wohnkomfort nachhaltig zu erhöhen. Sämtliche Arbeiten wurden gemäß den geltenden Qualitäts- und Ausführungsstandards durchgeführt.",
        client: "Privat",
        area: "400  m²",
        project_year: "2025",
        project_type: "Vollwärmeschutz",
        link: "/projects/laendliches-wohnhaus-mit-thermischer-sanierung",
        location:"Kärnten"
    },
    {
        id: 4,
        slug: "burggemauuer-denkmalschutz-und-mehr",
        project_name: "Burggemäuer, Denkmalschutz und mehr",
        project_img: burggemauuer_0,
        images: [burggemauuer_0, burggemauuer_4, burggemauuer_1, burggemauuer_2, burggemauuer_5,burggemauuer_6,burggemauuer_7,burggemauuer_8],
        project_desc: "Im Zuge der unter Denkmalschutz stehenden Renovierung der historischen Burggemäuer wurden ausgewählte Ausbauarbeiten sorgfältig und denkmalgerecht ausgeführt. Die Maßnahmen umfassten das Aufbringen eines neuen Innenputzes zur Stabilisierung und optischen Aufwertung der Innenflächen, das Einbringen eines Estrichs zur Herstellung tragfähiger und ebener Bodenflächen sowie die Erneuerung des Außenputzes zur langfristigen Erhaltung und Schutzwirkung der Fassaden. Dabei wurden sämtliche Arbeiten unter besonderer Rücksichtnahme auf den historischen Bestand umgesetzt.",
        client: "Privat",
        area: "1.000  m²",
        project_year: "2019",
        project_type: "Innenputz, Estrich und Außenputz",
        link: "/projects/burggemauuer-denkmalschutz-und-mehr",
        location:"Kärnten"
    }
   
]